import { lazy } from 'react';

export const TournamentsPageAsync = lazy(() =>
  import('./TournamentsPage').then((m) => ({ default: m.TournamentsPage })),
);
